import React, { useEffect, useState } from 'react';

import { logSearchInsightsEvent } from '~/common';

import { useAlgoliaInsights } from './useAlgoliaInsights';

type Props = {
  contentID: string | number;
  indexName: string;
};
export const useAlgoliaProductViewedEvent: React.FC<Props> = ({ contentID, indexName }) => {
  const { algoliaToken } = useAlgoliaInsights();
  const [isReported, setIsReported] = useState(false);

  useEffect(() => {
    if (!algoliaToken) {
      return;
    }
    if (isReported) {
      return;
    }

    logSearchInsightsEvent({
      index: indexName,
      type: 'viewedObjectIDs',
      eventName: 'Product Viewed',
      objectIDs: [String(contentID)],
    });
    setIsReported(true);
  }, [contentID, indexName, algoliaToken, isReported]);
  return null;
};
